<div
  class="floating-container"
  [style.--text-color]="textColor"
  [style.--color]="brandColor"
  [style.--gradiant-color]="gradiantColor"
  [style.--timer-text-color]="timerTextColor"
  [style.--border-color]="borderColor"
  [style.--border-shadow-color]="borderShadowColor"
  [style.--gradiant-secondary-color]="gradiantSecondaryColor"
  [class.extended]="extended"
  [class.edit-mode]="enableOrderEdit">
  <div class="inner-container" [ngStyle]="{ 'max-width': extended && enableOrderEdit ? '48rem' : '45rem' }">
    <div
      class="content"
      [class.extended]="extended"
      [class.hidden]="!enableOrderEdit && promotionProductsScrollState.shouldHide"
      [class.edit-mode]="enableOrderEdit"
      (click)="enableOrderEdit ? toggleExtended() : scrollToProductsCard.emit()">
      <div *ngIf="extended && enableOrderEdit" id="close-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="12" viewBox="0 0 30 12" fill="none">
          <path
            opacity="0.4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 11.2959L1.88197 4.73688C0.647021 4.11941 0.14646 2.61772 0.763934 1.38278C1.38141 0.14783 2.88309 -0.35273 4.11804 0.264743L15 5.70573L25.882 0.264745C27.1169 -0.352728 28.6186 0.147833 29.2361 1.38278C29.8535 2.61773 29.353 4.11941 28.118 4.73688L15 11.2959Z"
            fill="white" />
        </svg>
      </div>
      <ng-container *ngIf="!enableOrderEdit">
        <div class="extended-banner-content no-edit-mode" *ngIf="extended">
          <div class="banner-title">
            {{ bannerTitle }}
          </div>
        </div>
        <common-contained-down-arrow-icon [color]="buttonColor"></common-contained-down-arrow-icon>
      </ng-container>
      <ng-container *ngIf="enableOrderEdit">
        <div class="fixed-banner-content">
          <div class="main-texts">
            <div class="banner-title">
              {{ bannerTitle }}
            </div>
            <div class="banner-description">
              {{ bannerDescription }}
            </div>
          </div>
          <div class="countdown">
            <div>Ends in</div>
            <div class="time-left">
              <ng-container *ngIf="countdown.days">
                <div class="time-value">{{ countdown.days < 10 ? '0' + countdown.days : countdown.days }}</div>
                <div class="time-unit">D</div>
              </ng-container>
              <div class="time-value">{{ countdown.hours < 10 ? '0' + countdown.hours : countdown.hours }}</div>
              <div class="time-unit">H</div>
              <div class="time-value">{{ countdown.minutes < 10 ? '0' + countdown.minutes : countdown.minutes }}</div>
              <div class="time-unit">M</div>
              <ng-container *ngIf="!countdown.days">
                <div class="time-value">{{ countdown.seconds < 10 ? '0' + countdown.seconds : countdown.seconds }}</div>
                <div class="time-unit">S</div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="extended-banner-content edit-mode" *ngIf="extended">
          <common-promotion-products
            [promotionCode]="promotionDetails.promotionCode"
            [contained]="false"
            [brandColor]="elementsBackgroundColor"
            [textColor]="textColor"
            [data]="promotionProductsData"
            [fabVariant]="true"
            [discountPercent]="promotionDetails.productsDiscount"
            [orderStatus]="orderStatus"></common-promotion-products>
        </div>
      </ng-container>
    </div>
  </div>
</div>
